import React, { useRef, useState } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
import { parse, stringify } from 'query-string'

import { CloseButton } from '../../buttons/Buttons'
import { palette } from '../../../styles/variables'
import Modal from '../Modal'
import { LeftSection, RightSection, RightWrapper } from '../sharedStyles'
import AuthForm from '../checkoutModal/authForm'
import AshleeWhiteTestimonial from '../checkoutModal/testimonials/AshleeWhite'
import TrustPilot from '../checkoutModal/trustpilot'
import { useOnClickOutside } from '../../../utils/useOnClickOutside'
import { TurnstileProvider } from '../../turnstile'

import Title from './title'
import Arguments from './arguments'

const desktopStyle = {
  width: '95%',
  maxWidth: '900px',
  height: '740px',
  maxHeight: '90vh',
  borderRadius: '4px',
  display: 'flex',
  alignItems: 'stretch',
  justifyContent: 'stretch',
  position: 'relative',
  inset: 'auto',
  overflowY: 'auto',
  backgroundColor: palette.gray10,
}

const mobileStyle = {
  display: 'flex',
  flexDirection: 'column',
  minHeight: '100svh',
  backgroundColor: palette.gray10,
}
const SignupModal = ({
  isOpen,
  onClose,
  searchType,
  quantity,
  text,
  isAddProjectFlow,
  onAuthSuccess,
  maxLimitMessage,
}) => {
  const [authFormType, setAuthFormType] = useState('signup')
  const contentRef = useRef()
  const history = useHistory()

  const handleClose = () => {
    const parsed = parse(window.location.search)
    const {
      error: _error,
      checkout: _checkout,
      signup: _signup,
      type: _type,
      ...rest
    } = parsed
    history.replace({
      search: stringify(rest),
    })
    onClose?.()
  }

  useOnClickOutside(contentRef, handleClose)

  return (
    <Modal
      isOpen={isOpen}
      desktopStyle={desktopStyle}
      mobileStyle={mobileStyle}
      overlayStyle={{
        zIndex: 99999,
      }}
      contentRef={(el) => {
        contentRef.current = el
      }}
      shouldCloseOnOverlayClick
    >
      <CloseButton
        onClick={handleClose}
        styles={{ top: '20px', zIndex: '999' }}
      />
      <LeftSection>
        <Title
          interactionType={authFormType}
          searchType={searchType}
          text={text}
          quantity={quantity}
          isAddProjectFlow={isAddProjectFlow}
          maxLimitMessage={maxLimitMessage}
        />
        <TurnstileProvider
          WrappedComponent={AuthForm}
          onAuthSuccess={() => {
            if (isAddProjectFlow) {
              onAuthSuccess()
              return
            }
            window.location.reload()
          }}
          onClose={handleClose}
          isSignupModal
          setAuthFormType={setAuthFormType}
          isAddProjectFlow={isAddProjectFlow}
          searchType={searchType}
          text={text}
        />
      </LeftSection>
      <RightSection>
        <RightWrapper>
          <Arguments />
          <div style={{ marginTop: '48px' }}>
            <AshleeWhiteTestimonial />
            <TrustPilot style={{ marginTop: '24px' }} />
          </div>
        </RightWrapper>
      </RightSection>
    </Modal>
  )
}

export default SignupModal
